import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CodeOutlined } from "@ant-design/icons";
import { Button, Col, Popover, Row } from "antd";
import { Trans } from "@devowl-wp/react-frontend";
import { useTranslation } from "../../../../../../others/i18n.js";
import { colors } from "../../../../../../styles/colors.js";
import { QuillEditorWrapper } from "../../../../../third-party/quill-editor-wrapper.js";
const ServiceCodeEditorTip = ()=>{
    const { t } = useTranslation();
    const codeString = "<code>&lt;script skip-if-active=&quot;facebook-for-woocommerce,facebook-for-wp&quot;&gt;...&lt;/script&gt;</code>\n";
    return /*#__PURE__*/ _jsx(Row, {
        style: {
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 0,
            width: "100%"
        },
        children: /*#__PURE__*/ _jsx(Col, {
            flex: 1,
            style: {
                textAlign: "right"
            },
            children: /*#__PURE__*/ _jsx(Popover, {
                placement: "left",
                title: t("Code-Editor"),
                content: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsxs(Trans, {
                            children: [
                                /*#__PURE__*/ _jsx("strong", {
                                    children: "Attribute:"
                                }),
                                " ",
                                /*#__PURE__*/ _jsx("code", {
                                    children: "skip-if-active"
                                }),
                                /*#__PURE__*/ _jsx("br", {}),
                                /*#__PURE__*/ _jsx("strong", {
                                    children: "Description:"
                                }),
                                " Comma separated list of plugin slugs. When one of the plugins is active, the HTML tag will not be injected into the DOM.",
                                /*#__PURE__*/ _jsx("br", {}),
                                /*#__PURE__*/ _jsx("strong", {
                                    children: "Example:"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(QuillEditorWrapper, {
                            style: {
                                background: colors.main.background,
                                color: "black"
                            },
                            hiddenToolbar: true,
                            readOnly: true,
                            value: codeString
                        })
                    ]
                }),
                children: /*#__PURE__*/ _jsx(Button, {
                    type: "link",
                    icon: /*#__PURE__*/ _jsx(CodeOutlined, {}),
                    style: {
                        paddingRight: 0
                    },
                    children: t("Custom HTML attributes")
                })
            })
        })
    });
};
export { ServiceCodeEditorTip };
